<template>
    <el-form :inline="true" class="pl10" :model="form">
        <el-form-item class="width45">
            <el-select v-model="form.mzlb" placeholder="门诊类别" size="mini" @change="bookTypeChange">
                <el-option
                        v-for="item in mzlb"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item class="width45" v-if="form.mzlb==='1'">
            <el-select :value="currUserBookDoc.id" @change="bookDocChange" :disabled="docList.length===0"
                       placeholder="选择挂号医生" size="mini">
                <el-option
                        v-for="item in docList"
                        :key="item.id"
                        :label="item.bookDocName+'-'+item.bookDeptName"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item class="width45" v-if="form.mzlb==='2'">
            <el-select :value="currUserBookDoc.id" @change="bookDocChange" :disabled="deptList.length===0"
                       placeholder="选择挂号科室" size="mini">
                <el-option
                        v-for="item in deptList"
                        :key="item.id"
                        :label="item.bookDeptName"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
    </el-form>
</template>

<script>
    import {ONLINE_MZLB} from "../../lib/config";
    import {mapMutations, mapState} from 'vuex'

    export default {
        name: "online-filter",
        props: {
            type: {
                type: String,
                default: ''//1挂号医生,2按科室
            },
            value: {
                type: String,
                default: 'NEEDHANDLE'
            },
        },
        data() {
            return {
                mzlb: ONLINE_MZLB,
                dept: [],
                form: {
                    mzlb: '1'
                }
            }
        },
        computed: {
            ...mapState(['userBookDoc', 'currUserBookDoc']),
            docName() {
                let cur = this.currUserBookDoc
                return `${cur.bookDocName}-${cur.bookDeptName}`
            },
            docList() {
                let list = []
                this.userBookDoc.forEach(item => {
                    if (item.bookDocId) {
                        list.push(item)
                    }
                })
                return list
            },
            deptList() {
                let list = []
                this.userBookDoc.forEach(item => {
                    if (!item.bookDocId) {
                        list.push(item)
                    }
                })
                return list
            }
        },
        async mounted() {
            this.form.mzlb = this.currUserBookDoc.bookDocId? '1':'2'
        },
        watch: {
            form: {
                handler(newV) {
                    this.$emit('change', newV);
                },
                immediate: true,
                deep: true
            },
          currUserBookDoc:{
            handler(newV) {
              this.form.mzlb = newV.bookDocId? '1':'2'
            },
          }
        },
        methods: {
            ...mapMutations(['setCurrUserBookDoc']),
            bookDocChange(id) {
                const doc = this.userBookDoc.find(r => r.id === id);
                this.setCurrUserBookDoc(doc);
                this.$set(this.form, 'bookHosId', doc.bookHosId);
                this.$set(this.form, 'bookDocId', doc.bookDocId);
                this.$set(this.form, 'bookDeptId', doc.bookDeptId);
            },
            bookTypeChange(value) {
                //1-专家门诊 2-普通门诊
                let doc = value === '1'? this.docList[0] : this.deptList[0]
                if (doc){
                    this.setCurrUserBookDoc(doc);
                    this.$set(this.form, 'bookHosId', doc.bookHosId);
                    this.$set(this.form, 'bookDocId', doc.bookDocId);
                    this.$set(this.form, 'bookDeptId', doc.bookDeptId);
                } else {
                    this.$set(this.form, 'bookHosId', '');
                    this.$set(this.form, 'bookDocId', '');
                    this.$set(this.form, 'bookDeptId', '');
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .width45 {
        width: 45%;
    }
</style>
